import { Box } from '@chakra-ui/react'

export const RegistrationGuide: React.FC = () => {
  return (
    <Box mt={{ base: 4, md: 8 }} width="100%" height="100%">
        <iframe
        src="https://www.magichow.co/embed/ede7aa4c-b4d3-4cf3-8d40-15385c708937?showTitle=false"
        sandbox="allow-scripts allow-top-navigation-by-user-activation allow-popups allow-same-origin"
        title="Maurya Samaj - User Registration & Login"
        width="100%"
        height="100%"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        style={{ border: "none", borderRadius: "8px" }}
        />
    </Box>
  )
}
